import * as t from "io-ts";

export const FontWeightV = t.union([
  t.literal("100"),
  t.literal("200"),
  t.literal("300"),
  t.literal("400"),
  t.literal("500"),
  t.literal("600"),
  t.literal("700"),
  t.literal("800"),
  t.literal("900")
]);

export const CustomTypographyInputValueV = t.type({
  customTypography: t.UnknownRecord
});

export type CustomTypographyInputValue = t.TypeOf<
  typeof CustomTypographyInputValueV
>;

export const TypographyPresetIdV = t.string;

export type TypographyPresetId = t.TypeOf<typeof TypographyPresetIdV>;

export const TypographyPresetLabelAndIdV = t.type({
  label: t.string,
  id: TypographyPresetIdV
});

export type TypographyPresetLabelAndId = t.TypeOf<
  typeof TypographyPresetLabelAndIdV
>;

export const TypographyPresetV = t.intersection([
  t.type({ preset: TypographyPresetLabelAndIdV }),
  t.partial({
    custom: CustomTypographyInputValueV
  })
]);

export type TypographyPreset = t.TypeOf<typeof TypographyPresetV>;

export const TypographyInputValueV = t.union([
  t.type({
    preset: t.union([t.undefined, TypographyPresetIdV]),
    previousCustom: t.union([t.undefined, CustomTypographyInputValueV])
  }),
  t.type({
    custom: CustomTypographyInputValueV
  })
]);

export type TypographyInputValue = t.TypeOf<typeof TypographyInputValueV>;
